module.exports = __webpack_public_path__ + "static/media/MISC.04914ce5.svg";